import type { AnnotationLabelT } from '../../types/types';

// W3C standard coefficients for relative luminance calculation
// Based on human eye sensitivity to different color wavelengths
const LUMINANCE_RED_COEFFICIENT = 0.2126;
const LUMINANCE_GREEN_COEFFICIENT = 0.7152;
const LUMINANCE_BLUE_COEFFICIENT = 0.0722;
export const getRandomRGBColor = () => {
  let r: number;
  let g: number;
  let b: number;
  let luminance: number;
  const minLuminance = 0.4; // Minimum perceived brightness (0-1 scale)
  const minValue = 80; // Minimum RGB component value
  const maxValue = 255;
  const range = maxValue - minValue;
  do {
    r = Math.floor(Math.random() * range) + minValue;
    g = Math.floor(Math.random() * range) + minValue;
    b = Math.floor(Math.random() * range) + minValue;

    // Calculate relative luminance using W3C standard formula
    // https://www.w3.org/WAI/GL/wiki/Relative_luminance
    const rNorm = r / 255;
    const gNorm = g / 255;
    const bNorm = b / 255;
    luminance = LUMINANCE_RED_COEFFICIENT * rNorm + LUMINANCE_GREEN_COEFFICIENT * gNorm + LUMINANCE_BLUE_COEFFICIENT * bNorm;
  } while (luminance < minLuminance);
  return `rgb(${r},${g},${b})`;
};
export const getLastInstanceCount = (baseTitle: string, labelTitles: string[]) => labelTitles.reduce((lastInstanceCount, labelTitle) => {
  if (labelTitle === baseTitle) return lastInstanceCount;
  const instanceBaseTitle = labelTitle.slice(0, labelTitle.lastIndexOf('_'));
  const instanceSuffix = labelTitle.slice(labelTitle.lastIndexOf('_') + 1);
  if (instanceBaseTitle !== baseTitle) return lastInstanceCount;
  const instanceNumber = Number(instanceSuffix);
  return Number.isInteger(instanceNumber) ? Math.max(lastInstanceCount, instanceNumber) : lastInstanceCount;
}, 0);
export const getInstanceTitle = (title: string, instanceLabels: {
  title: string;
  color: string;
}[]) => {
  if (instanceLabels.length === 0) return title + '_1';
  const lastInstanceCount = getLastInstanceCount(title, instanceLabels.map(instanceLabel => instanceLabel.title));
  return title + '_' + (lastInstanceCount + 1);
};
export const getInitialLabels = (annotationLabels: AnnotationLabelT[], initialLabels: AnnotationLabelT[]): ({
  instanceLabels: {
    title: string;
    color: string;
  }[];
} & AnnotationLabelT)[] => {
  return annotationLabels.map(label => {
    const instanceLabels = [];
    initialLabels.forEach(initialLabel => {
      const labelTitleArr = initialLabel.title.split('_');
      if (labelTitleArr[0] === label.title && labelTitleArr.length > 1) {
        // @ts-expect-error missing null check
        instanceLabels.push({
          title: initialLabel.title,
          color: initialLabel.style.fillColor
        });
      }
    });
    instanceLabels.sort((a, b) => {
      // @ts-expect-error missing null check
      const aArr = a.title.split('_');
      // @ts-expect-error missing null check
      const bArr = b.title.split('_');
      return parseInt(aArr[1]) > parseInt(bArr[1]) ? 1 : -1;
    });
    return {
      ...label,
      instanceLabels
    };
  });
};